class EditoSlider extends HTMLElement {
  constructor() {
    super();
    
    this.currentIndex = 0;
    this.images = null;
    this.navButtons = null;
    this.autoplayInterval = null;
  }

  connectedCallback() {
    this.images = this.querySelectorAll('[data-ref="edito-image"]');
    this.navButtons = this.querySelectorAll('[data-ref="edito-nav-button"]');
    const autoplay = this.getAttribute('data-autoplay') === 'true';
    
    if (!this.images.length || !this.navButtons.length) return;

    this.#initNavigation();
    this.#showImage(0);

    if (autoplay) {
      this.#startAutoplay();
      this.#setupAutoplayPause();
    }
  }

  disconnectedCallback() {
    this.#stopAutoplay();
  }

  #initNavigation() {
    this.navButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        this.#stopAutoplay();
        this.#showImage(index);
      });
    });
  }

  #showImage(index) {
    if (index < 0 || index >= this.images.length) return;

    this.images.forEach((image, i) => {
      if (i === index) {
        image.classList.add('is-active');
        image.removeAttribute('hidden');
      } else {
        image.classList.remove('is-active');
        image.setAttribute('hidden', '');
      }
    });

    this.navButtons.forEach((button, i) => {
      if (i === index) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    this.currentIndex = index;
  }

  #startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      const nextIndex = (this.currentIndex + 1) % this.images.length;
      this.#showImage(nextIndex);
    }, 6000);
  }

  #stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  #setupAutoplayPause() {
    this.addEventListener('mouseenter', () => this.#stopAutoplay());
    this.addEventListener('mouseleave', () => this.#startAutoplay());
  }
}

if (!customElements.get('edito-slider')) {
  customElements.define('edito-slider', EditoSlider);
}

